<template>
  <div>
    <b-alert
      :show="getNotification.show"
      :variant="getNotification.type"
      dismissible
      class="alert alert-elevate"
      @dismissed="
        getNotification.message = '';
        getNotification.show = false;
      "
      @dismiss-count-down="10"
    >
      {{ getNotification.message }}
    </b-alert>

    <div class="row">
      <div class="col-md-12">
        <MPortlet
          v-bind.sync="{
            title: 'Manage Users',
            isLoading: isLoading,
            loadingText: loadingMessage
          }"
        >
          <template v-slot:toolbar>
            <router-link
              :to="{ name: 'create-admin-user' }"
              class="btn btn-label-success btn-sm btn-bold"
              v-if="userCan('add-users')"
            >
              <i class="la la-pencil-square"></i>
              Add New
            </router-link>
            <button
              @click="reloadRecords()"
              class="btn btn-label-primary btn-sm btn-bold"
            >
              <i class="la la-refresh"></i>
              Reload
            </button>
          </template>
          <template v-slot:body>
            <v-card :flat="true">
              <!-- <v-card-title>
                Filter Records
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title> -->
              <v-data-table
                item-key="id"
                :headers="headers"
                :items="getRecordsList"
                :options.sync="options"
                :server-items-length="getPagination.total"
                :loading="isLoading"
                loading-text="Loading... please wait"
                :items-per-page="per_page"
                :page="getPagination.current_page"
                :footer-props="footerProps"
                show-select
                v-model="selected"
                class="elevation-0"
              >
                <template v-slot:item.role="{ item }">
                  {{ item.role.display_name }}
                </template>
                <template v-slot:item.avatar="{ item }">
                  {{ item.avatar_url }}
                  <v-avatar
                    v-if="item.avatar && item.avatar.indexOf('default') < 0"
                    size="36px"
                  >
                    <img alt="Avatar" :src="item.avatar_link" />
                  </v-avatar>
                  <v-avatar v-else color="red">
                    <span class="white--text headline">
                      {{ item.name.substr(0, 1) }}
                    </span>
                  </v-avatar>
                </template>
                <template v-slot:item.status="{ item }">
                  <span v-if="item.status > 0" class="label label-success">
                    Active
                  </span>
                  <span v-else class="label label-warning">
                    Disabled
                  </span>
                </template>
                <template v-slot:item.created_at="{ item }">
                  {{ item.created_at | moment("YYYY-MM-DD H:mm a") }}
                </template>
                <template v-slot:item.id="{ item }">
                  <div class="text-left">
                    <v-btn
                      small
                      class="ma-1 pt-0 pb-0 pr-2 pl-3"
                      tile
                      outlined
                      color="primary"
                      @click="viewRecord(item.id)"
                      v-if="checkRole(item) && userCan('read-users')"
                    >
                      <v-icon left>mdi-eye</v-icon> View
                    </v-btn>
                    <v-btn
                      small
                      class="ma-1 pt-0 pb-0 pr-2 pl-3"
                      tile
                      outlined
                      color="success"
                      @click="editRecord(item.id)"
                      v-if="checkRole(item) && userCan('edit-users')"
                    >
                      <v-icon left>mdi-pencil</v-icon> Edit
                    </v-btn>
                    <v-btn
                      small
                      class="ma-1 pt-0 pb-0 pr-2 pl-1"
                      tile
                      outlined=""
                      color="error"
                      @click="deleteRecord(item.id)"
                      v-if="checkRole(item) && userCan('delete-users')"
                    >
                      <v-icon>mdi-delete</v-icon> Delete
                    </v-btn>
                  </div>
                </template>
              </v-data-table>
              <v-fab-transition>
                <v-btn
                  v-if="selected.length"
                  color="error"
                  fab
                  small
                  dark
                  top
                  right
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </v-fab-transition>
            </v-card>
          </template>
        </MPortlet>
      </div>
    </div>
    <v-dialog v-model="showView" width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">View Permission</span>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="5">
              <strong>Name</strong>
            </v-col>
            <v-col cols="7">
              {{ getActiveRecord.name }}
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="5">
              <strong>Display Name</strong>
            </v-col>
            <v-col cols="7">
              {{ getActiveRecord.display_name }}
            </v-col>
          </v-row>
          <v-row v-if="getActiveRecord.created_at">
            <v-col cols="5">
              <strong>Created At</strong>
            </v-col>
            <v-col cols="7">
              {{ getActiveRecord.created_at | moment("YYYY-MM-DD H:mm a") }}
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red"
            class="white--text"
            @click="deleteRecord(getActiveRecord.id)"
            v-if="checkRole(getActiveRecord, true) && userCan('delete-users')"
            >Delete</v-btn
          >
          <v-btn
            color="primary"
            @click="editRecord(getActiveRecord.id)"
            v-if="checkRole(getActiveRecord) && userCan('edit-users')"
            >Edit</v-btn
          >
          <v-btn color="default" @click="showView = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/store/breadcrumbs.module";
import MPortlet from "@/views/partials/content/MPortlet.vue";
import { SET_ACTIVE_DATA } from "@/consts";

export default {
  name: "Users",
  components: {
    MPortlet
  },
  metaInfo: {
    title: "Users"
  },
  data() {
    return {
      storeNamespace: "adminUsers",
      search: null,
      selected: [],
      per_page: 25,
      options: {},
      headers: [
        { text: "Name", value: "name" },
        { text: "Email", value: "email" },
        { text: "Role", value: "role" },
        { text: "Avatar", value: "avatar" },
        { text: "Status", value: "status" },
        { text: "Created", value: "created_at" },
        {
          text: "",
          value: "id",
          align: "left",
          sortable: false,
          filterable: false,
          width: 200
        }
      ],
      sortParams: {},
      footerProps: {
        "items-per-page-options": [25, 50, 100, 500]
      },
      loadingMessage: "Busy...",
      showView: false
    };
  },
  beforeMount() {
    const reqPerm = this.$route.meta.users;

    if (reqPerm.length && !this.$auth().can(reqPerm[0])) {
      return this.$router.replace({ name: "admin-403" });
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Users" }]);
    this.fetchRecords(this.options);
  },
  computed: {
    ...mapGetters("adminUsers", [
      "getRecordsList",
      "isLoading",
      "getPagination",
      "getErrors",
      "getActiveRecord"
    ]),
    getNotification() {
      return this.notification;
    }
  },
  watch: {
    options: {
      handler(options) {
        if (!this.isLoading) {
          this.fetchRecords(options);
        }
      },
      deep: true
    },
    getPagination: {
      handler(data) {
        this.options = {
          page: data.current_page,
          itemsPerPage: data.per_page,
          sortBy: [this.sortParams.name],
          sortDesc: [this.sortParams.direction === "desc"]
        };
      },
      deep: true
    }
  },
  methods: {
    reloadRecords() {
      let params = {
        page: 1,
        per_page: this.per_page,
        sort: this.sortParams.name,
        direction: this.sortParams.direction
      };

      this.setLoading(true);
      this.$store
        .dispatch(this.addNamespace("getList"), { ...params })
        .then(() => {
          this.setLoading(false);
          this.notification = {
            type: "success",
            message: "Data Loaded"
          };
        });
    },
    fetchRecords(options) {
      let params = {
        page: 1,
        per_page: this.per_page,
        sort: this.sortParams.name,
        direction: this.sortParams.direction
      };

      if (options.page) {
        params = {
          ...params,
          ...{
            page: options.page,
            per_page: options.itemsPerPage,
            sort: options.sortBy[0] || "created_at",
            direction: options.sortDesc[0] ? "desc" : "asc"
          }
        };
      }

      this.setLoading(true);
      this.$store
        .dispatch(this.addNamespace("getList"), { ...params })
        .then(() => {
          this.setLoading(false);
          this.notification = {
            type: "success",
            message: "Data Loaded"
          };
        });
    },
    viewRecord(id) {
      this.$store.commit(this.addNamespace(SET_ACTIVE_DATA), id);
      this.showView = true;
    },
    editRecord(id) {
      this.$store.commit(this.addNamespace(SET_ACTIVE_DATA), id);
      this.$router.push({ name: "edit-admin-user", params: { id } });
    },
    deleteRecord(id) {
      this.$confirm({
        message: "Are you sure you want to delete selected record?",
        confirmText: "Delete",
        cancelText: "Cancel"
      }).$on("confirmed", confirmed => {
        if (confirmed) {
          this.setLoading(true, "Please wait...");

          this.$store
            .dispatch(this.addNamespace("deleteRecord"), id)
            .then(response => {
              if (response.success) {
                this.$alert({
                  title: "Success!",
                  message: response.message
                });
              } else {
                this.$alert({
                  title: "Operation Failed!",
                  message: response.message
                });
              }
            })
            .catch(() => {
              this.$alert({
                title: "Error:",
                message: "Unable to delete record"
              });
            })
            .then(() => {
              this.setLoading(false);
            });
        }
      });

      // console.log(id);
    },
    maxRecord() {
      // console.log(this.selected);
    },
    setStatus(type, message) {
      this.notification = {
        type: type,
        message: message,
        show: true
      };
    },
    checkRole(data) {
      if (data.id == 1) {
        return this.userHasRole(data.id, true);
      }

      return true;
    },
    checkSelf(data, isDelete) {
      const auth = this.$auth();

      if (
        isDelete &&
        (auth.user.id === data.id || (data.role && data.role.id == 1))
      ) {
        return false;
      }
    }
  }
};
</script>
